import { useAuth } from '../context/AuthContext';
import {
  Package, SignOut, List, Users, Scales, ChartBar
} from '@phosphor-icons/react';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const DPLUS_LOGO = "/assets/dplus-logo.jpg";

const navItems = [
  { id: '/', label: 'Products', icon: Package },
  { id: '/admin', label: 'Manage Users', icon: Users, adminOnly: true },
];

export function Sidebar() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const isAdmin = user?.role === 'admin';

  return (
    <>
      <button data-testid="sidebar-toggle" onClick={() => setCollapsed(!collapsed)}
        className="md:hidden fixed top-4 left-4 z-50 w-10 h-10 rounded-lg bg-[#0F172A] text-white flex items-center justify-center shadow-lg">
        <List size={20} weight="bold" />
      </button>
      {!collapsed && <div className="md:hidden fixed inset-0 bg-black/40 z-30" onClick={() => setCollapsed(true)} />}
      <aside data-testid="sidebar" className={`fixed md:static z-40 top-0 left-0 h-screen w-60 bg-[#0F172A] text-white flex flex-col transition-transform duration-300 ${collapsed ? '-translate-x-full md:translate-x-0' : 'translate-x-0'}`}>
        <div className="flex items-center gap-3 px-5 py-5 border-b border-slate-800">
          <img src={DPLUS_LOGO} alt="Design Plus" className="w-9 h-9 rounded-lg object-cover" />
          <div>
            <span className="text-lg font-bold tracking-tight" style={{ fontFamily: 'Outfit' }}>Design Plus</span>
            <p className="text-[10px] uppercase tracking-widest text-slate-400">Pricing Hub</p>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {navItems.map(item => {
            if (item.adminOnly && !isAdmin) return null;
            const Icon = item.icon;
            const active = location.pathname === item.id;
            return (
              <button key={item.id} data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
                onClick={() => { navigate(item.id); setCollapsed(true); }}
                className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${active ? 'bg-slate-800 text-white' : 'text-slate-400 hover:text-slate-200 hover:bg-slate-800/50'}`}>
                <Icon size={20} weight={active ? 'fill' : 'regular'} />
                {item.label}
              </button>
            );
          })}
        </nav>
        <div className="px-4 py-4 border-t border-slate-800">
          <div className="flex items-center gap-3 mb-3 px-2">
            <div className="w-8 h-8 rounded-full bg-[#2563EB] flex items-center justify-center text-xs font-bold">
              {user?.name?.[0]?.toUpperCase() || 'U'}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-white truncate">{user?.name || 'User'}</p>
              <p className="text-xs text-slate-400 truncate">{user?.email}</p>
            </div>
          </div>
          <button data-testid="logout-btn" onClick={logout}
            className="w-full flex items-center gap-2 px-4 py-2 rounded-lg text-sm text-slate-400 hover:text-red-400 hover:bg-slate-800/50 transition-all duration-200">
            <SignOut size={18} /> Sign Out
          </button>
        </div>
      </aside>
    </>
  );
}
